import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useProjectSection,
  useFind: useProjectSections,
  useCreate: useProjectSectionsCreation,
  useUpdate: useProjectSectionsUpdate,
  useDelete: useProjectSectionsDeletion,
} = getCRUDHooks({
  entityName: 'projectSections',
  get: ({ projectId, sectionId }) =>
    clientApi.getOCClient().helpers.learningContent.projects.id(projectId).sections.get(sectionId),
  find: ({ projectId, filters }) =>
    clientApi.getOCClient().helpers.learningContent.projects.id(projectId).sections.find(filters),
  create: ({ title }, { projectId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.create({ title }),
  update: (values, { projectId, sectionId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.partialUpdate(sectionId, values),
  remove: ({ projectId, sectionId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .sections.delete(sectionId),
});

export {
  useProjectSection,
  useProjectSections,
  useProjectSectionsCreation,
  useProjectSectionsUpdate,
  useProjectSectionsDeletion,
};
